// extracted by mini-css-extract-plugin
export default {"Badge":"styles_Badge__PExmg","active":"styles_active__zxu0o"};